/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 08.07.25
 *
 */

import {debounce} from "vue-debounce";
import {isObject} from "@/utils/helpers";


export const qwDebounce = function (fn, wait) {

	let isDebouncePending = false

	let debounced = debounce((...args) => {
		isDebouncePending = false
		console.log("qwDebounce.debounce: isDebouncePending = ", isDebouncePending, ", args = ", args)
		fn.apply(this, args);
	}, wait)

	const debouncedFn = function (...args) {
		if(isLastArgCallImmediately(args)) {
			debouncedFn.callImmediately.apply(this, args);
			return;
		}
		isDebouncePending = true
		console.log("qwDebounce.debouncedFn: isDebouncePending = ", isDebouncePending, " args = ", args)
		debounced.apply(this, args)
	}

	debouncedFn.cancel = () => {
		isDebouncePending = false
		console.log("qwDebounce.debouncedFn.cancel: isDebouncePending = ", isDebouncePending)
		debounced.cancel()
	}

	debouncedFn.callImmediately = (...args) => {
		console.log("qwDebounce.debouncedFn.callImmediately: isDebouncePending = ", isDebouncePending, ", args = ", args)
		debouncedFn.cancel()
		fn.apply(this, args)
	}
	debouncedFn.isDebouncePending = () => {
		return isDebouncePending
	}
	debouncedFn.original = () => {
		return fn
	}

	return debouncedFn

}

function isLastArgCallImmediately(args) {
	if (args.length === 0) {
		return false;
	}
	let lastArg = args[args.length - 1];
	return isObject(lastArg) && lastArg.callImmediately;
}
